import React from 'react';
import { Typography } from '@mui/material';
import { UserMenu } from './Users/UserMenu';
import ActionTableButton from '../../components/common/ActionButtonAndMenu/ActionTableButton';

export const columns = [
    {
        fieldName: 'userName',
        name: 'userName',
        label: 'USER NAME/EMAIL ID',
        type: 'string',
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]}
            </Typography>
        ),
    },
    {
        fieldName: 'firstName',
        name: 'firstName',
        label: 'FIRST NAME',
        type: 'string',
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]}
            </Typography>
        ),
    },
    {
        fieldName: 'lastName',
        name: 'lastName',
        label: 'LAST NAME',
        type: 'string',
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]}
            </Typography>
        ),
    },
    {
        fieldName: 'mobileNumbers',
        name: 'mb',
        label: 'MOBILE NUMBER',
        type: 'string',
        filter: true,
        disableSorting: true,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]?.[0]}
            </Typography>
        ),
    },
    {
        fieldName: 'passwordExpired',
        name: 'passExp',
        label: 'PASSWORD EXPIRED',
        type: 'boolean',
        filter: true,
        disableSorting: true,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName] ? 'Yes' : 'No'}
            </Typography>
        ),
    },
    {
        fieldName: 'accountLocked',
        name: 'accountLocked',
        label: 'ACCOUNT LOCKED',
        type: 'boolean',
        filter: true,
        disableSorting: true,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName] ? 'Yes' : 'No'}
            </Typography>
        ),
    },
    {
        fieldName: 'enabled',
        name: 'accountEnabled',
        label: 'ACCOUNT ENABLED',
        type: 'boolean',
        filter: true,
        disableSorting: true,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName] ? 'Yes' : 'No'}
            </Typography>
        ),
    },
    {
        id: 'action',
        label: 'Actions',
        filter: true,
        sticky: true,
        formatValue: ({ row, keyColumn, action }) => {
            const roles = row['roles'];
            const role = (Array.isArray(roles) && roles.length > 0 ? Object.keys(roles[0]) : roles) || [];
            return (
                <UserMenu
                    Component={ActionTableButton}
                    row={{ ...row, roleList: role }}
                    keyColumn={keyColumn}
                    handleAction={action}
                />
            );
        },
    },
];
